import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imNotificationsBell', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/notifications/bell/notifications-bell.html'),
        controller: 'NotificationsBellController',
        controllerAs: 'NotificationsBellCtrl',
        bindings: {},
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/notifications/bell/notifications-bell.component.ts